export function getOptionLabel<T>(
  options: ReadonlyArray<{ value: T | ReadonlyArray<T>; label?: string }>,
  value: T
) {
  const [target] = options.filter((item) => {
    if (Array.isArray(item.value)) {
      return item.value.includes(value);
    }
    return item.value === value;
  });
  return target?.label || "";
}
